import { useCallback, useEffect, useState } from 'react';
import { useEventListener } from '@direct-frontend/stdlib';
import { getWindow } from '../getWindow';
import { getRequestContext } from '../requestContext';

const TOUCH_DESKTOP_MEDIA = 767;

export const useIsDesktop = () => {
    const { platform } = getRequestContext();

    const [isDesktop, setIsDesktop] = useState(platform === 'desktop');

    const resizeListener = useCallback(() => {
        const window = getWindow();

        if (!window) {
            return;
        }

        setIsDesktop(window.innerWidth > TOUCH_DESKTOP_MEDIA);
    }, []);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Автоматический игнор в рамках DIRECT-288723
        resizeListener();
    });

    useEventListener('resize', resizeListener, undefined, { passive: true });

    return { isDesktop };
};
